import { map } from 'rxjs/operators';
import { CardViewModel } from 'src/models/card-view-model';
import { PersonViewModel } from 'src/models/person-view-model';
import { TimestampTypeViewModel } from 'src/models/timestamp-type-view-model';
import {
  TimestampRecord,
  TimestampViewModelBase,
} from 'src/store/generated/timestamp-record.generated';
import { TimestampTypeRecord } from 'src/store/generated/timestamp-type-record.generated';
import { formatDate } from 'src/util/date';
import { timeElapsed } from 'src/util/helpers/date-helper';
import { ViewModelService } from '../app/shared/view-model.service';

export class TimestampViewModel extends TimestampViewModelBase {
  public readonly card: CardViewModel;
  public readonly type: TimestampTypeViewModel;
  public readonly timeString: string;

  get person$() {
    return this._model
      .getPersonById(this.userId)
      .pipe(map((p) => (p == null ? PersonViewModel.systemUser : p)));
  }

  get timeElapsed() {
    return timeElapsed(this.time);
  }

  get description() {
    return this.note != null ? `${this.type.name} - ${this.note}` : this.type.name;
  }

  get personsInvolvedDetials() {
    return this.personsInvolved != null ? `Persons Involved - ${this.personsInvolved}` : null;
  }

  constructor(
    timestamp: TimestampRecord,
    timestampType: TimestampTypeRecord,
    card: CardViewModel,
    private _model: ViewModelService,
  ) {
    super(timestamp);
    this.card = card;
    this.type = new TimestampTypeViewModel(timestampType);
    this.timeString = formatDate(timestamp.time, 'MM/dd/yyyy HH:mm:ss');
  }
}
